import { Box, Chip, Typography } from "@mui/material";
import SoundCloudWidgets from "../../components/SoundCloudWidgets";
import DateIcon from "../../assets/DateIcon";
import LocationIcon from "../../assets/LocationIcon";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useEvent } from "../../hooks/useEvent";
import PageLoader from "../../components/PageLoader";
import { sanitizeHtml } from "../../utils/safeHtml";
import styles from "./styles";

const EventPage = () => {
  const { id } = useParams();
  const { data: event, isLoading, error } = useEvent(id);

  return (
    <PageLoader isLoading={isLoading} error={error} errorMessage="Failed to load event">
      <Box sx={styles.pageWrapperSx}>

        <Box component="img" src={event?.imageURL} alt={event?.name} sx={styles.imageSx} />

        <Typography variant="h4" sx={styles.titleSx}>
          {event?.name}
        </Typography>

        {/* Date & Location */}
        <Box sx={styles.metaRowSx}>
          <Box sx={styles.metaItemSx}>
            <DateIcon fill="#c7c7c7" />
            <Typography sx={styles.metaTextSx}>
              {moment(event?.date).format("MMMM Do, YYYY")}
            </Typography>
          </Box>
          <Box sx={styles.metaItemSx}>
            <LocationIcon />
            <Typography sx={styles.metaTextSx}>{event?.location}</Typography>
          </Box>
        </Box>

        {/* Price */}
        {event?.price && (
          <Box sx={styles.priceRowSx}>
            <LocalOfferIcon sx={styles.iconSx} />
            <Typography variant="body1">{`Ticket - ${event.price} GEL`}</Typography>
          </Box>
        )}

        {/* Doors open */}
        {event?.startTime && (
          <Box sx={styles.timeRowSx}>
            <AccessTimeIcon sx={styles.iconSx} />
            <Typography variant="body1">{`Doors Open - ${event.startTime}`}</Typography>
          </Box>
        )}

        {/* Lineup */}
        {!!event?.lineup?.length && (
          <Box sx={styles.genresRowSx}>
            {event.lineup.map((artist) => (
              <Chip key={artist} label={artist} variant="outlined" color="primary" />
            ))}
          </Box>
        )}

        {/* Genres */}
        {!!event?.genres?.length && (
          <Box sx={styles.genresRowSx}>
            {event.genres.map((genre) => (
              <Chip key={genre} label={genre} variant="filled" color="primary" />
            ))}
          </Box>
        )}

        {/* Description — sanitized HTML from rich text editor */}
        {event?.description && (
          <Box
            sx={styles.descriptionSx}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(event.description) }}
          />
        )}

        <Box sx={styles.clearSx} />

        <SoundCloudWidgets recordings={event?.recordings || []} description="Below you will find recordings related to this event" />
      </Box>
    </PageLoader>
  );
};

export default EventPage;
